export const btoaUrlSafe = str =>
  window.btoa(str).replace('/', '_').replace('+', '-').replace(/[=]+$/, '')
